// Libraries
import React, {FunctionComponent, ReactElement} from 'react';
import {Button} from 'antd';
import PropTypes from 'prop-types';

// Functions
import {isEmpty} from '../../utils/generalUtils';


type ButtonComponentType = {
  htmlType?: 'submit' | 'reset' | 'button' | undefined;
  className?: string;
  text: string;
  loading?: boolean;
  icon?: ReactElement | null;
  onClick?: () => void;
};
const ButtonComponent: FunctionComponent<ButtonComponentType> = (
  {
    htmlType, className, text, loading, icon, onClick,
  }) => {
  const textIsEmpty = isEmpty(text);

  return (
    <Button htmlType={htmlType} loading={loading} icon={icon}
            className={`${textIsEmpty ? 'h-7 ' : 'h-8 '}` +
              'rounded-md ext-sm font-medium shadow-md ' + className
            }
            onClick={onClick}>
      {text}
    </Button>
  );
}

ButtonComponent.propTypes = {
  htmlType: PropTypes.oneOf(['submit', 'reset', 'button', undefined]),
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  icon: PropTypes.element,
  onClick: PropTypes.func,
};

export default ButtonComponent;